import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store/store";

Vue.config.productionTip = false;
export const bus = new Vue();

new Vue({
  render: h => h(App),
  router,
  store
}).$mount("#app");
